// src/app/materials.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Materials } from  '../../../Materials';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MaterialsService {
    
  private apiUrl = environment.apiUrl +'materials'; // Replace with your API endpoint

  constructor(private http: HttpClient) {}

  GetMaterials(): Observable<Materials[]> {
    return this.http.get<Materials[]>(this.apiUrl);
  }

  
  getMaterial(id:number): Observable<Materials> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.get<Materials>(url);
  }



  addMaterial(material: Materials): Observable<Materials> {
    return this.http.post<Materials>(this.apiUrl, material);
  }

  editMaterial(material: Materials): Observable<Materials> {
    const url = `${this.apiUrl}/${material.id}`;
    return this.http.put<Materials>(url, material);
  }
}
